<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="title">
			<el-form class="form-inlines" :inline="true">
				<el-form-item label="日期:">
					<el-date-picker v-model="formData.time" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="医生:">
					<el-select v-model="formData.docname" placeholder="请选择" size="small" filterable clearable>
						<el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态:">
					<el-select v-model="formData.type" placeholder="请选择" size="small" filterable clearable>
						<el-option v-for="item in  formData.type_options" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
				<el-table-column prop="promoter" label="ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="promoterUser.nickname" label="用户名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="patient_name" label="头像" align="center">
					<template slot-scope="scope">
						<el-image style="width: 80px; height: 80px" :src="scope.row.promoterUser.avatar" fit="cover">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="sumprice" label="邀请消费金额" show-overflow-tooltip>

				</el-table-column>

				<el-table-column prop="sumprice" label="邀请记录" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button type="success" size="small" @click="openlist(scope.row)">查看</el-button>
					</template>
				</el-table-column>

			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>

		<el-dialog title="邀请记录" :visible.sync="invlistdialogs" top="40px" width="70%" center class="dialogs"
			@close='closeinv'>
			<!-- <el-divider></el-divider> -->
			<div class="add_tits" ref="title" style="padding:0 15px">
				<el-form class="form-inlines" :inline="true">
					<el-form-item label="日期:">
						<el-date-picker v-model="invformData.invtime" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="invformData.invtype" placeholder="请选择" size="small" filterable clearable>
							<el-option v-for="item in  invformData.type_options" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="searchinvlist">搜索
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="invlisttableData" border v-loading="invloading" :height="invheights"
				ref="configurationTable">
				<el-table-column prop="user" label="用户" align="center" width="150">
					<template slot-scope="scope">
						<div>
							<el-image style="width: 50px; height: 50px" :src="scope.row.user.avatar" fit="cover">
							</el-image>
							<div>{{scope.row.user.nickname}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ship_status_text" label="收货状态" show-overflow-tooltip width="90">
				</el-table-column>
				<el-table-column prop="refund_status_text" label="退款状态" show-overflow-tooltip width="90">
				</el-table-column>
				<el-table-column prop="price" label="消费金额" show-overflow-tooltip width="90"> </el-table-column>
				<el-table-column prop="goodsItem" label="下单商品" show-overflow-tooltip width="120">
					<template slot-scope="scope">
						<div>
							<el-image style="width: 50px; height: 50px" :src="scope.row.goodsItem.cover" fit="cover">
							</el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="goodsItem.title" label="商品名称" show-overflow-tooltip> </el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @current-change="invlisthandleCurrentChange" :current-page="invlistcurrentPage"
						layout="total, prev,pager, next" :total="invlistcount">
					</el-pagination>
				</div>
			</div>
			<!-- <el-divider></el-divider> -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="invlistdialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>




	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				formData: {
					time: '',
					docname: '',
					doc_options: [],
					sexname: '',
					bzname: '',
					bz_options: [],
					type: '',
					type_options: [{
							id: 1,
							name: '已收货'
						},
						{
							id: 2,
							name: '退款中'
						},
					],
				},
				invformData: {
					invtime: '',
					invtype: '',
					type_options: [{
							id: 1,
							name: '已收货'
						},
						{
							id: 2,
							name: '退款中'
						},
					],
				},

				loading: false,
				tableData: [],
				currentPage: 1,
				pagesize: 15,
				count: 0,
				heights: null,
				invheights: null,

				invlistdialogs: false,
				invlisttableData: [],
				invloading: false,
				invlistcurrentPage: 1,
				invlistpagesize: 15,
				invlistcount: 0,
				invuser_id: 0,

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getall()
			that.getHeight()
			this.getDate6()
			// that.begin()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				var title = that.$refs.title.offsetHeight
				that.heights = window.innerHeight - title - 200 + 'px'
				that.invheights = window.innerHeight - title - 230 + 'px'
				window.onresize = () => {
					var title = that.$refs.title.offsetHeight
					that.invheights = window.innerHeight - title - 230 + 'px'
					that.heights = window.innerHeight - title - 200 + 'px'
				}
			},
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios
					.post("/admin/pc/orderItem/promoterOrder", {
						page: that.currentPage,
						page_count: that.pagesize,
						start_time: this.formData.time ? this.formData.time[0] : '',
						end_time: this.formData.time ? this.formData.time[1] : '',
						type: this.formData.type,
						promoter: this.formData.docname,
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.count
					})
					.catch(error => {})
			},

			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			searchinvlist() {
				let that = this
				that.invloading = true
				let invtime = this.invformData.invtime
				axios
					.post("/admin/pc/orderItem/promoterDetail", {
						page: that.invlistcurrentPage,
						start_time: invtime ? invtime[0] : '',
						end_time: invtime ? invtime[1] : '',
						type: this.invformData.invtype,
						user_id: this.invuser_id,
					}, {
						token: true
					})
					.then(response => {
						that.invloading = false
						that.invlisttableData = response.data.data.list
						that.invlistcount = response.data.data.count
					})
					.catch(error => {})
			},
			
			invlisthandleCurrentChange(val) {
				let that = this
				that.invlistcurrentPage = val;
				that.searchinvlist()
			},
			closeinv() {
				this.invformData.invtype = ''
				this.invformData.invtime = []
			},
			getall() {
				this.getdoc()
				this.getbzxx()
			},
			openlist(row) {
				this.invuser_id = row.promoterUser.id
				this.searchinvlist()
				this.invlistdialogs = true
			},
			getdoc() {
				axios
					.post("/admin/User/userList", {
						// type: 'select',
						limit: 10000,
					}, {
						token: true
					})
					.then(response => {
						this.formData.doc_options = response.data.data.list
					})
					.catch(error => {})
			},
			getbzxx() {
				axios
					.post("/admin/KkysKnowledgeDisease/showDiseaseList", {}, {
						token: true
					})
					.then(response => {
						this.formData.bz_options = response.data.data
					})
					.catch(error => {})
			},

			// 市
			getsq() {
				let that = this
				that.formData.city = ''
				that.formData.city_options = []
				axios
					.post("/admin/Area/getChild_vue", {
						parentcode: that.formData.province,
					}, {
						token: true
					})
					.then(response => {
						that.formData.city_options = response.data.data
					})
					.catch(error => {})
			},
			getDate6() {
				let that = this
				var date = new Date();
				date.setDate(1);
				var month = parseInt(date.getMonth() + 1);
				var day = date.getDate();
				month = month < 10 ? "0" + month : month;
				day = day < 10 ? "0" + day : day;
				var start = date.getFullYear() + "-" + month + "-" + day;
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				month = month < 10 ? "0" + month : month;
				var day = new Date(year, month, 0);
				var end = year + "-" + month + "-" + day.getDate();
				that.formData.time = [start, end]
				that.begin()
			},


		},

	};
</script>

<style lang="scss" scoped>
	.inv_user {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
</style>